export default function About() {
  const features = [
    {
      icon: 'fa-award',
      title: '전문성',
      description: '15년 이상의 물류 노하우와 전문 인력'
    },
    {
      icon: 'fa-shield-alt',
      title: '신뢰성',
      description: '99.8% 물류 정확도와 안전한 보관 시스템'
    },
    {
      icon: 'fa-rocket',
      title: '혁신성',
      description: '최신 WMS와 자동화 시스템 도입'
    },
    {
      icon: 'fa-headset',
      title: '고객지원',
      description: '24/7 실시간 고객 지원 서비스'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="text-cyan-600 font-semibold mb-2 tracking-wider text-sm">ABOUT US</p>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">로지뷰를 선택하는 이유</h2>
            <p className="text-gray-600 text-lg mb-10 leading-relaxed">
              로지뷰는 15년 이상의 물류 전문 경험과 최첨단 기술을 바탕으로
              고객사의 성공적인 비즈니스를 지원하는 3PL 전문기업입니다.
            </p>

            <div className="space-y-6">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-4">
                  <div className="flex-shrink-0 w-14 h-14 bg-cyan-100 rounded-lg flex items-center justify-center">
                    <i className={`fas ${feature.icon} text-cyan-600 text-xl`}></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">{feature.title}</h4>
                    <p className="text-gray-600 text-sm">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="aspect-square rounded-2xl overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/2de9e8192ae00a75b7d7b36ef2548e1c/c36ba730a6fd16cb7f329c579d310fc1.png" 
                alt="로지뷰 물류센터" 
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-xl">
              <div className="text-3xl font-bold text-cyan-600 mb-1">500+</div>
              <div className="text-gray-600 text-sm">만족한 고객사</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}